import React, { useMemo } from "react"
import { observer } from "mobx-react"
import { Col, Row } from "antd"

// import { QuestionCircleOutlined } from "@ant-design/icons"
// import Tippy from "@tippyjs/react"
import { balancesStore } from "@src/app/balanceStore"
import { BalancesPageList } from "@src/pages/balances/balancePage"
import css from "./index.module.css"

// const tooltipText =
//   "Pending Balance shows the total amount of pay-ins and pay-outs that have not yet been finalized"

export const BalancesPage = observer(() => {
  const { summary } = balancesStore

  const hasSummary = useMemo(() => {
    // Pending balances are temporarily hidden.
    // return summary.totals?.available || summary.totals?.diff
    return summary.totals?.available
  }, [summary])

  return (
    <Row gutter={20}>
      <Col span={hasSummary ? 18 : 24}>
        <BalancesPageList />
      </Col>
      {hasSummary && (
        <Col span={6}>
          <div className={css.totalBlock}>
            <div className={css.totalWrapper}>
              <span className={css.totalDescription}>Total value</span>
              <span
                className={css.totalValue}
              >{`~ $ ${summary.totals?.available || 0}`}</span>
            </div>
            {/* Pending balances are temporarily hidden.
            <div className={css.totalWrapper}>
              <div className={css.tooltipWrapper}>
                <span className={css.totalDescription}>Pending balance</span>
                <Tippy className={css.tooltip} content={tooltipText}>
                  <QuestionCircleOutlined style={{ color: "#1C6C2A" }} />
                </Tippy>
              </div>
              <span
                className={css.totalValue}
              >{`~ $ ${summary.totals?.diff || 0}`}</span>
            </div>
            */}
          </div>
        </Col>
      )}
    </Row>
  )
})
